import script from "./ClientLogos.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientLogos.vue?vue&type=script&setup=true&lang=js"

import "./ClientLogos.vue?vue&type=style&index=0&id=eb227d18&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.32_vue@3.5.32_webpack@5.106.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eb227d18"]])

export default __exports__